export default __webpack_public_path__ + "static/Entenda0022-bf5a1f90e54196422f9c1325b3b9b04d.jpg";